<template>
    <div class="user-lists-modal set-spot-dates-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner" v-if="spot">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Title -->
            <h2>Add to Schedule</h2>

            <div class="spot-details">
                <img :src="spot.feature_image_lg" :alt="spot.title">
                <div class="text-info">
                    <h3 v-if="spot.subcategory && spot.neighborhood" v-text="strLimit(spot.title, 55)"></h3>
                    <div v-if="spot.subcategory && spot.neighborhood" class="details">
                        <span v-text="spot.subcategory.title"></span> in <span v-text="spot.neighborhood.title"></span>
                    </div>
                    <h3 v-if="!spot.subcategory && !spot.neighborhood" v-text="spot.title"></h3>
                </div>
            </div>

            <p>What day(s) are you going?</p>

            <!-- Form -->
            <form :action="`/lists/${currentList.id}/schedules/${spot.slug}`" @submit.prevent="submit" method="post">

                <ul class="list-dates">
                    <template v-for="(day, index) in scheduleDays">
                        <li>
                            <div class="dates">
                                <h3 v-text="printTripDay(day)"></h3>
                                <div class="date-text" v-if="currentList.trip_date" v-text="printTripDate(day)"></div>
                            </div>
                            <toggle-checkmark v-model="form.trip_days" :day="day"></toggle-checkmark>
                        </li>
                    </template>
                </ul>

                <div class="actions">
                    <button type="button" class="btn-all-dates" @click="selectAll()">Select all Dates</button>
                    <button type="button" class="btn-clear-dates" @click="clearAll()">Clear Selection</button>
                </div>

                <button type="submit"
                        class="btn-submit"
                        v-text="`Confirm ${form.trip_days.length} ${pluralize('day', form.trip_days.length)}`">
                </button>
            </form>
        </div>

    </div>
</template>
<script>

import Form from "@/classes/Form"
import Helpers from "@/mixins/Helpers"
import ToggleCheckmark from "./ToggleCheckmark"

export default {

    mixins: [Helpers],

    components:{
        ToggleCheckmark
    },

    props: ['list'],

    data() {
        return {
            currentTab: null,
            currentList: this.list,
            spot: null,
            schedules: [],
            scheduleDays: this.list.trip_days,
            form: new Form({
                trip_days: [],
            })
        }
    },

    mounted() {
        if (!this.currentList.is_schedule_available) {
            return
        }
        eventBus.$on('schedule-updated', response => {
            console.log('schedule-updated');
            this.scheduleDays = response.trip_days
            this.schedules = response.schedule_dates
        })
        eventBus.$on('open-add-to-schedule-modal', this.openModal);
        eventBus.$on('list-updated', this.updatedList)
    },

    methods: {

        submit() {
            this.form.post(`/lists/${this.currentList.id}/schedules/${this.spot.slug}`)
                .then(response => {
                    this.resetForm()
                    this.closeModal()
                    eventBus.$emit('fetch-schedule', {
                        tab: this.currentTab
                    })
                })
                .catch(errors => {
                    console.error(errors)
                })
        },

        resetForm() {
            this.form = new Form({
                trip_days: []
            })
        },

        printTripDay(day) {
            // check if is not the owner as well
            if (this.currentList.trip_date == null || this.currentList.user_id != window.config.user.id) {
                return `Day ${day}`;
            }
            let newDate = moment(this.currentList.trip_date).add(day, 'days')
            return newDate.format('dddd')
        },

        printTripDate(day) {
            let newDate = moment(this.currentList.trip_date).add(day, 'days')
            return newDate.format('MMM Do')
        },

        openModal(data) {
            this.resetForm()
            this.spot = data.spot
            this.currentTab = data.tab
            this.setInitalSchedulesForm()
            this.$nextTick(() => {
                $('.set-spot-dates-list-dialog').fadeIn()
                let timeout = setTimeout(() => {
                    document.body.classList.add('no-scroll')
                    clearTimeout(timeout)
                }, 500)
            })
        },

        closeModal() {
            document.body.classList.remove('no-scroll')
            $('.set-spot-dates-list-dialog').fadeOut();
            this.spot = null
        },

        updatedList(event) {
            this.currentList = event.list
            this.scheduleDays = this.currentList.trip_days
        },

        selectAll() {
            this.form.trip_days = Array.from(Array(this.currentList.trip_days).keys()).map(index => {
                return {
                    day: (index + 1),
                    time: null,
                }
            })
        },

        clearAll() {
            this.form.trip_days = []
        },

        setInitalSchedulesForm() {
            let dates = Object.keys(this.schedules)
            for (let day in dates) {
                day = parseInt(day)
                let result = _.find(this.schedules[dates[day]], schedule => {
                    return schedule.spot_id == this.spot.id
                })
                if (result) {
                    this.form.trip_days.push({
                        day: (day + 1),
                        time: null
                    })
                }
            }
        }
    }
}
</script>

